import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'substring'
})
export class SubStringPipe implements PipeTransform {

    transform(value: any, numberWord: number): unknown {
        if(value && value.length > numberWord) return value.substring(0, numberWord)+'...';
        return value;
    }

}
